<template>
    <van-popup v-model="isShow"
        :overlay="true"
        :closeable="true"
        :round="true"
        :close-on-click-overlay="false"
        :duration="0"
        @close="closeModal">
        <div class="guide-limit-modal"
            :class="{'is-guide-list-modal':isSpecialStyle}">
            <div class="popup-title"
                :class="{'mr-25px':isSpecialStyle}">{{ popupTitle }}</div>
            <div v-if="isGuideList"
                class="guide-list">
                <div v-for="(item) in qywxGuideList"
                    :key="item.guideUserId"
                    class="guide-item">
                    <div class="guide-avatar">
                        <img :src="item.userAvatar || defaultAvatar"
                            alt="" />
                    </div>
                    <!-- 超过四个字点点点处理，避免溢出 -->
                    <div class="guide-name">{{ item.userName }}</div>
                    <div class="add-btn"
                        :class="{'mr-25px':isSpecialStyle}"
                        @click="addGuide(item)">加好友</div>
                </div>
            </div>
            <div v-if="isOneGuide"
                class="one-guide">
                <div class="qr-code">
                    <img :src="guideItem.userQrCode"
                        alt="" />
                </div>
                <div class="qr-tips">
                    长按识别二维码
                </div>
                <div v-if="showSwitchBtn"
                    class="switch-guide"
                    @click="switchGuide()">切换导购</div>
            </div>
        </div>
    </van-popup>
</template>
<script>
import { Popup } from 'vant';
import { ActivityType } from '../../../../../commons/commonVariables.js';
export default {
  components: {
    [Popup.name]: Popup,
  },
  props: {
    /**
     * 活动类型
     */
    activityType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isShow: false,
      guideItem: {},
      showSwitchBtn: false,
      defaultAvatar: require('../../../../../../static/runtime/images/magic/award/userImg.png'),
      qywxGuideList: [], // 距离消费者最近门店的导购列表
    };
  },
  computed: {
    isGuideList() {
      return this.qywxGuideList && this.qywxGuideList.length > 1 && JSON.stringify(this.guideItem) === '{}';
    },
    isOneGuide() {
      return (this.qywxGuideList && this.qywxGuideList.length === 1) || JSON.stringify(this.guideItem) !== '{}';
    },
    isSpecialStyle() {
      // 超过3个导购需调整列表滚动条样式
      return this.qywxGuideList && this.qywxGuideList.length > 3 && JSON.stringify(this.guideItem) === '{}';
    },
    popupTitle() {
      let title = '';
      if (this.activityType === ActivityType.bigTurnable) {
        title = '添加导购企微好友，获得抽奖机会';
      } else if (this.activityType === ActivityType.thematicActivity) {
        title = '添加导购企微好友，再来领取奖品吧';
      }
      return title;
    },
  },
  watch: {
    qywxGuideList: {
      handler(newVal) {
        if (newVal && newVal.length === 1) {
          this.guideItem = newVal[0];
        } else {
          this.guideItem = {};
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    openModal(list) {
      this.isShow = true;
      this.qywxGuideList = list || [];
    },
    addGuide(item) {
      this.guideItem = item;
      this.showSwitchBtn = true;
    },
    switchGuide() {
      this.guideItem = {};
      this.showSwitchBtn = false;
    },
    closeModal() {
      this.isShow = false;
      this.showSwitchBtn = false;
      this.guideItem = {};
    },
  },
};
</script>
<style lang="scss" scoped>
.is-guide-list-modal {
  padding: 30px 10px 40px 35px !important;
}
.guide-limit-modal {
  width: 85.3vw;
  padding: 30px 35px 40px;

  .popup-title {
    font-size: 14px;
    color: #000000;
    text-align: center;
    font-weight: 400;
  }
  .mr-25px {
    margin-right: 25px !important;
  }
  .guide-list {
    height: 27vh;
    overflow: scroll;
    margin-top: 8vw;
    .guide-item {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-bottom: 10px;
      .guide-avatar {
        height: 13.3vw;
        width: 13.3vw;
        img {
          width: 100%;
          height: 100%;
          border-radius: 50% !important;
        }
      }
      .guide-name {
        font-size: 15px;
        color: #000000;
        flex-grow: 1;
        padding: 10px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 30%;
      }
      .add-btn {
        background: #ffffff;
        border: 1px solid #b6b6b6;
        border-radius: 40px;
        color: #000000;
        width: 26.7vw;
        height: 4.1vh;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 15px;
      }
    }
  }
  .one-guide {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    margin-top: 5vw;
    .qr-code {
      width: 35.2vw;
      height: 17.5vh;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .qr-tips {
      margin-top: 3vw;
      font-size: 14px;
      color: #999999;
      text-align: center;
      line-height: 20px;
      font-weight: 400;
      padding: 0 20px;
    }
    .switch-guide {
      background: #ffffff;
      border: 1px solid rgba(182, 182, 182, 1);
      border-radius: 40px;
      font-size: 15px;
      color: #222222;
      text-align: center;
      line-height: 32px;
      font-weight: 400;
      width: 26.7vw;
      margin-top: 2vh;
    }
  }
}

/deep/ .van-popup--round {
  border-radius: 12px !important;
}

/deep/ .van-popup__close-icon {
  font-size: 20px !important;
  color: #999 !important;
}

/deep/ .van-popup__close-icon--top-right {
  top: 14px !important;
  right: 14px !important;
}
</style>



// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/dynamicAttr/modal/qywxGuideLimitModal.vue